import { writable } from "svelte/store";

const stored_client_login = localStorage.getItem("is_client_login");
export const client_login = writable(stored_client_login);

client_login.subscribe(value => {
    console.log(value)
    localStorage.setItem("is_client_login", value ? value : 0);
});